import React from 'react';
import {Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Box, Switch} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import EventIcon from '@mui/icons-material/Event';
import CampaignIcon from '@mui/icons-material/Campaign';
import {Logout} from "@mui/icons-material";
import { useThemeToggle } from '../../ThemeProviderWrapper';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {useAppDispatch} from "../../app/hooks";
import {logout} from "../../features/auth/authSlice";


const drawerWidth = 240;

const SideBar: React.FC = () => {
    const { mode, toggleTheme } = useThemeToggle();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const handleLogout = () => {
        dispatch(logout());
    };

    const menuItems = [
        { text: 'Players', icon: <SportsSoccerIcon />, path: '/Players' },
        { text: 'Clients', icon: <EventIcon />, path: '/Clients' },
        { text: 'Advertisers', icon: <CampaignIcon />, path: '/Advertisers' },
        { text: 'Users', icon: <PeopleAltIcon />, path: '/Users' },
        { text: 'Logout', icon: <Logout/>, path: '/login', onClick: handleLogout},
    ];

    return (
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ px: 2, py: 1 }}>
                <Switch checked={mode === 'dark'} onChange={toggleTheme} />
            </Box>
            <List>
                {menuItems.map((item) => (
                    <ListItemButton
                        key={item.text}
                        component={Link}
                        to={item.path}
                        selected={location.pathname === item.path}
                        onClick={item.onClick}
                    >
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.text} />
                    </ListItemButton>
                ))}
            </List>
        </Drawer>
    );
};

export default SideBar;
